<template>
  <v-card>
    <v-card-title>
      Promo Products
      <v-spacer />
      <v-text-field
        v-model="search"
        outlined
        clearable
        hide-details
        class="mr-2"
        dense
        label="Search"
      />
      <v-select
        v-model="categoryId"
        outlined
        :items="categoriesToShow"
        clearable
        label="Category"
        hide-details
        class="min-width mr-2"
        item-value="id"
        item-text="name"
        dense
      />
      <v-btn
        class="mr-2"
        outlined
        @click="openSyncDialog"
      >
        <v-icon class="mr-1">sync</v-icon>
        Sync by Id
      </v-btn>
      <v-btn
        @click="refreshProducts"
        :loading="loading"
      >
        Sync
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-data-table
      :loading="loading"
      :headers="headers"
      :search="search"
      :items="items"
    >
      <template #[`item.categories`]="{ item }">
        <div
          v-for="(category, i) in item.categories"
          :key="i"
        >
          {{ category.name }}
        </div>
      </template>
      <template #[`item.isAvailable`]="{ item }">
        <v-icon
          v-if="item.isAvailable"
          color="success"
        >
          mdi-check
        </v-icon>
      </template>
      <template #[`item.syncDate`]="{ item }">
        {{ item.syncDate | normalDateWithTime }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          :to="`/promo/products/${item.id}`"
          class="mr-2"
        >
          Edit
        </v-btn>
        <v-btn
          class="mr-2"
          outlined
          :loading="refreshing.includes(item.id)"
          @click="refresh(item.id)"
        >
          <v-icon class="mr-1">refresh</v-icon>
          Sync
        </v-btn>
      </template>
    </v-data-table>
    <LoadingSpinnerDialog :loading="loading_dialog" />
    <v-dialog
      v-model="syncDialog"
      width="500"
      @click:outside="closeSyncDialog"
    >
      <v-card light>
        <v-btn
          class="float-right"
          icon
          @click="closeSyncDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-title class="px-8 pt-12"> Sync Product by External Id </v-card-title>
        <v-card-text class="px-8">
          <v-text-field
            v-model="externalId"
            outlined
            clearable
            label="External Id"
            hide-details="auto"
            autofocus
            @keyup.enter="syncByExternalId"
          />
        </v-card-text>
        <v-card-actions class="px-8 pb-6">
          <v-spacer />
          <v-btn
            text
            @click="closeSyncDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="syncingExternalId"
            :disabled="!externalId"
            @click="syncByExternalId"
          >
            Sync
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { flatten, orderBy, uniqBy } from 'lodash';

import { mapGetters } from 'vuex';
export default {
  name: 'PromoProducts',
  components: {},
  data: () => ({
    loading: true,
    loading_dialog: false,
    refreshing: [],
    syncDialog: false,
    externalId: '',
    syncingExternalId: false,
    search: '',
    headers: [
      { text: 'Category', value: 'categories' },
      { text: 'Name', value: 'name' },
      { text: 'Available?', value: 'isAvailable' },
      { text: 'Sync Date', value: 'syncDate' },
      { text: '', value: 'actions' }
    ],
    categoryId: null
  }),
  computed: {
    items() {
      let list = this.list;
      if (this.categoryId) {
        if (this.categoryId !== 'none') {
          list = list.filter((x) => x.categories.includes((y) => y.id === this.categoryId));
        }
      }
      return orderBy(list, ['createdDate'], ['desc']);
    },
    categoriesToShow() {
      if (this.list && this.list.length) {
        let list = [{ id: 'none', name: '*** No Category ***' }];

        list = list.concat(uniqBy(flatten(this.list.map((x) => x.categories)), 'id'));
        return list;
      }
      return [];
    },
    ...mapGetters({
      list: 'promo/list'
    })
  },
  created() {
    this.loadData(true);
  },
  methods: {
    refreshProducts() {
      this.loading = true;
      this.$store
        .dispatch('promo/refreshProducts')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refresh(id) {
      this.refreshing.push(id);
      this.$store
        .dispatch('promo/refreshProduct', id)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.refreshing = this.refreshing.filter((x) => x !== id);
        });
    },
    openSyncDialog() {
      this.externalId = '';
      this.syncDialog = true;
    },
    closeSyncDialog() {
      if (this.syncingExternalId) {
        return;
      }
      this.syncDialog = false;
    },
    syncByExternalId() {
      if (!this.externalId) {
        return;
      }
      this.syncingExternalId = true;
      this.$store
        .dispatch('promo/refreshProductByExternalId', this.externalId.trim())
        .then((product) => {
          this.$root.$snackbarSuccess(`Synced "${product.name}"`);
          this.syncDialog = false;
          this.externalId = '';
          this.loadData();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.syncingExternalId = false;
        });
    },
    loadData(initial) {
      this.loading = true;
      const calls = [this.$store.dispatch('promo/getAllProducts')];
      Promise.all(calls)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
